

export enum ESubscriptionProvider {
  IAP = "inapp_purchase",
  STRIPE = "stripe",
}
export enum ESubsctiptionGrantType {
  PURCHASED = "purchased",
  ADMIN = "admin_given",
  PARTNERSHIP = "partnership",
}
export enum EDocumentType {
  PRESCRIPTION = "prescription",
  MEDICAL_RECORD = "medicalRecord",
}
export enum EQuestionaireQuestionType {
  MULTIPLE_CHOICE = "multiple_choice",
  SINGLE_CHOICE = "single_choice",
  TEXT = "text",
  RATING = "rating",
}